import { InputAdornment, TextField } from "@mui/material";
import { isNumber } from "lodash";
import { formatMileage } from "../../../../utils/labels/formatDistance";
import { mileageToMeters } from "../../../../utils/conversion/distance";
import { ConditionValueSelectorComponent } from "../ConditionForm";
import LocaleProvider from "../../../../providers/LocaleProvider";
import { useTranslation } from "react-i18next";
import { testIds } from "./MileageInput.testIds";

const MileageInput: ConditionValueSelectorComponent = ({
  value,
  onChange,
  label,
}) => {
  const { t } = useTranslation("billingRules");
  return (
    <TextField
      type="number"
      value={isNumber(value) ? formatMileage(value, false) || "" : ""}
      onChange={(event) => {
        onChange(mileageToMeters(parseFloat(event.target.value) || 0));
      }}
      size="small"
      label={label || t("target.MILEAGE", "Mileage")}
      inputProps={{ "data-testid": testIds.mileageInputMiles,
        type: "number",
        min: 0,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            {LocaleProvider.getMileageUnit()}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default MileageInput;
